import { BillingPage, ProfilePage, SessionsPage, SubscriptionPage, TermsPage } from "./AccountPages";
import { PasswordChangePage } from "./PasswordChangePage";

export function AccountPageRouter({ routeId }: { readonly routeId: string }) {
  switch (routeId) {
    case "MEM-S10": return <SubscriptionPage />;
    case "MEM-S11": return <BillingPage />;
    case "MEM-S12": return <SessionsPage />;
    case "MEM-S13": return <ProfilePage />;
    case "MEM-S14": return <TermsPage />;
    case "MEM-S21": return <PasswordChangePage />;
    default: return null;
  }
}
